import { TranslateService } from '@ngx-translate/core';

/**
 * Translation service to handle the multilingual approach
 * Created by Ashok on 05-04-2016.
 **/
import { Injectable } from "@angular/core";
import * as  en_data from '../assets/i18n/en.json'
import * as  hi_data from '../assets/i18n/hi.json';
import * as _ from 'underscore';



// import * as myGolfLang from 'jquery'
/**
 *
 */
var myGolfLang: any;
@Injectable()
export class TranslationService {
  private lang: string = "en";
  en_data: any = (en_data as any).default;
  labels = {};

  constructor(
    public translateService: TranslateService
  ) {
    translateService.use(this.lang)
    translateService.setDefaultLang(this.lang);
  }

  public setLanguage(lang: string) {
    this.lang = lang;
  }

  getLanguage() {
    return this.lang;
  }

  changeLanguage(lang: string) {
    if (["en", "hi"].indexOf(lang) !== -1) {
      this.lang = lang;
      this.translateService.setDefaultLang(this.lang);
      this.translateService.use(this.lang);
    }
  }

  public translate(text: string): string {
    let translated: any = text;
    let parts: Array<string> = this.splitParts(text);
    if (this.lang == 'en') {
      if (parts && parts[0] && parts[1]) {
        if (en_data[parts[0]] != null && en_data[parts[0]] != undefined) {
          for (const [key, value] of Object.entries(en_data[parts[0]])) {
            if (key == parts[1]) {
              translated = value
            }
          }
        }
      }
    } else {
      if (parts && parts[0] && parts[1]) {
        if (hi_data[parts[0]] != null && hi_data[parts[0]] != undefined) {
          for (const [key, value] of Object.entries(hi_data[parts[0]])) {
            if (key == parts[1]) {
              translated = value
            }
          }
        }
      }
    }
    return translated;
  }

  private splitParts(text: string): Array<string> {
    return text.split(".");
  }
}

